import { FC } from 'react'
import { BasicComponentType } from './social-media-cell.types'

import { formatCash } from '@lua-frontend/utils'
import { InstagramSVG, TiktokSVG } from '../../assets'

const openInstagramProfile = (instagramUrl: string) => {
  if (instagramUrl) {
    if (window) {
      window.open(instagramUrl, '_blank')
    }
  }
}

const openTiktokProfile = (tiktokUrl: string) => {
  if (tiktokUrl) {
    if (window) {
      window.open(tiktokUrl, '_blank')
    }
  }
}

const Followers: FC<BasicComponentType> = ({
  instagramValue,
  tiktokValue,
  tiktokUrl,
  instagramUrl,
  bottomText,
}) => {
  return (
    <div className="max-w-32 flex w-fit flex-col items-center justify-center">
      {/* text replaced with grey-95 */}
      <div className="flex w-full items-center justify-center gap-x-1 text-grey-95">
        <div>
          {instagramValue !== undefined &&
            instagramValue.toString().length > 0 && (
              <div className="flex items-center gap-0.5">
                {instagramValue.toString() !== '0' && (
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      if (instagramUrl) {
                        openInstagramProfile(instagramUrl)
                      }
                    }}
                  >
                    <InstagramSVG />
                  </span>
                )}
                <div className="flex items-center">
                  <p className="m-0 font-montserrat text-sm font-semibold">
                    {formatCash(instagramValue)}
                  </p>
                </div>
              </div>
            )}
        </div>
        <div>
          {tiktokValue !== undefined && tiktokValue.toString().length > 0 && (
            <div className="flex items-center gap-0.5">
              {tiktokValue.toString() !== '0' && (
                <span
                  className="cursor-pointer"
                  onClick={() => {
                    if (tiktokUrl) {
                      openTiktokProfile(tiktokUrl)
                    }
                  }}
                >
                  <TiktokSVG />
                </span>
              )}
              <div className="flex items-center">
                <p className="m-0 font-montserrat text-sm font-semibold">
                  {formatCash(tiktokValue)}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      <div>
        <p className="m-0 mt-0.5 font-montserrat text-xs font-light text-grey-50">
          {bottomText}
        </p>
      </div>
    </div>
  )
}

const Engagement: FC<BasicComponentType> = ({
  instagramValue,
  tiktokValue,
  tiktokUrl,
  instagramUrl,
  bottomText,
}) => {
  return (
    <div className="max-w-32 flex w-fit flex-col items-center justify-center">
        {/* text replaced with grey-95 */}
      <div className="flex w-full items-center justify-center gap-x-1 text-grey-95">
        <div>
          {instagramValue !== undefined && (
            <div className="flex items-center gap-0.5">
              <span
                className="cursor-pointer"
                onClick={() => {
                  if (instagramUrl) {
                    openInstagramProfile(instagramUrl)
                  }
                }}
              >
                <InstagramSVG />
              </span>
              <div className="flex items-center">
                <p className="m-0 font-montserrat text-sm font-semibold">
                  {instagramValue > 0.01 ? instagramValue : '< 0.01'}
                </p>
                <p className="m-0 font-montserrat text-xs font-normal">%</p>
              </div>
            </div>
          )}
        </div>
        <div>
          {tiktokValue !== undefined && (
            <div className="flex items-center gap-0.5">
              <span
                className="cursor-pointer"
                onClick={() => {
                  if (tiktokUrl) {
                    openTiktokProfile(tiktokUrl)
                  }
                }}
              >
                <TiktokSVG />
              </span>
              <div className="flex items-center">
                <p className="m-0 font-montserrat text-sm font-semibold">
                  {tiktokValue > 0.01 ? tiktokValue : '< 0.01'}
                </p>
                <p className="m-0 font-montserrat text-xs font-normal">%</p>
              </div>
            </div>
          )}
        </div>
      </div>
      <div>
        <p className="m-0 mt-0.5 font-montserrat text-xs font-light text-grey-50">
          {bottomText}
        </p>
      </div>
    </div>
  )
}

export { Engagement, Followers }
